import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { rejectRecognition } from 'api/recognitions.service';
import { useToast } from 'hooks/ui';
import { useApplicationStore } from 'store/application';
import { setDraftRecognition } from 'store/recognition';
import { recognitionKeys } from './queryKeys';

export const useRecognitionRejectQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore();

  const { isPending, mutate } = useMutation({
    mutationFn: (id: string) => {
      setLoading();

      return rejectRecognition(id);
    },
    onSuccess: (recognition) => {
      toast.success('Recognition has been rejected successfully');
      setDraftRecognition(recognition);
    },
    onError: (error: AxiosError) => {
      toast.error(error.message);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: recognitionKeys.all });
      removeLoading();
    },
  });

  return { isLoading: isPending, mutate };
};
